<template>
  <div class="chat-page__wrapper">
    <!-- Toggle Button for Mobile -->
    <div v-if="isMobile"
      class="draggable">
      <div ref="headerWrapper" 
        class="header__wrapper" 
        :style="iframeProperty.layout === 'widget' ? { backgroundColor: iframeProperty.buttonBackgroundColour, color: iframeProperty.buttonTextColour } : {}"
        >
        <!-- Toggle Button -->
        <button @click="toggleSidebar" type="button" class="toggle_button"
         :style="iframeProperty.layout === 'widget' ? { color: iframeProperty.buttonTextColour } : {}"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="icon-lg mx-2 text-token-text-secondary">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3 8C3 7.44772 3.44772 7 4 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H4C3.44772 9 3 8.55228 3 8ZM3 16C3 15.4477 3.44772 15 4 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H4C3.44772 17 3 16.5523 3 16Z"
              fill="currentColor"></path>
          </svg>
        </button>
        <div v-if="iframeProperty.layout === 'widget'" class="header__content">
          <div class="header__content__title">{{ iframeProperty.headerTitle }}</div>
          <div class="header__content__description">{{ iframeProperty.headerDescription }}</div>
        </div>
      </div>
    </div>
    <!-- Side Bar -->
    <section :class="['side-bar', { 'side-bar--open': sidebarOpen && isMobile }]">
      <div v-if="isMobile">
        <div class="header__wrapper">
          <!-- Toggle Button -->
          <button @click="toggleSidebar" type="button" class="toggle_button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="icon-lg mx-2 text-token-text-secondary">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3 8C3 7.44772 3.44772 7 4 7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H4C3.44772 9 3 8.55228 3 8ZM3 16C3 15.4477 3.44772 15 4 15H14C14.5523 15 15 15.4477 15 16C15 16.5523 14.5523 17 14 17H4C3.44772 17 3 16.5523 3 16Z"
                fill="currentColor"></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="button-container">
        <button id="newChatButton" @click="() => startNewConversation()">
          + New Conversation</button>
      </div>
      <div ref="convoContainer" class="conversation-summaries">
        <!-- Display conversation summaries here -->
        <div
          class="conversation-summary"
          v-for="(conversation, index) in conversationSummaries"
          :key="index"
          :class="{ active: index === currentConversationIndex }"
        >
        <span 
        @click="loadConversation(index)"
        >
          <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="icon-sm" style="color: white; margin-right: 10px;" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </span>
        <span
        @click="loadConversation(index)"
        class="conversation-name"
        >
          {{ conversation.name }}
        </span>
         <span class="delete-icon"><svg width="16" height="16" @click.stop="deleteConversation(index)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Delete</title><path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/></svg></span>
        </div>
      </div>
      <nav>
        <span @click="login">Login</span>
      </nav>
    </section>
    <!-- Main Section -->
    <section class="main">
      <div v-if="conversationTurnLimitReached" class="conversation-limit-container">
        <span class="conversation-limit-message">{{ conversationTurnLimitText }}</span>
        <button class="conversation-limit-button" @click="() => startNewConversation()">
          + New Conversation
        </button>
      </div>
      <div v-else class="input-container">
        <!-- Image attach button and hidden file input -->
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          multiple
          style="display:none"
          @change="onImagesSelected"
        />
        <button
          class="attach-button"
          :disabled="disableInput"
          title="Attach image"
          @click.prevent="triggerFilePicker"
        >
          📎
        </button>
        <textarea
          id="userInput"
          placeholder="Type any query"
          v-model="userInputText"
          @keydown.enter.exact="sendMessage"
          @keydown.shift.enter="newline"
          rows="1"
          wrap="soft"
          :disabled="disableInput"
        />
        <button class="pi pi-send" id="submit" @click="sendMessage"> </button>
      </div>
      <!-- Image preview chips (multiple) -->
      <div v-if="!conversationTurnLimitReached && attachedImagePreviews.length" class="image-previews">
        <div class="image-preview" v-for="(src, idx) in attachedImagePreviews" :key="src">
          <img :src="src" alt="attached preview" />
          <span class="image-name">{{ attachedImages[idx]?.name }}</span>
          <button class="remove-image" @click="removeAttachedImage(idx)" title="Remove image">✕</button>
        </div>
      </div>
      <div  ref="chatContainer" class="output-container">
        <div 
          v-if="chatHistory.length === 0 && isNewConversation"
          class="empty-conversation-message"
        > 
          <div class="welcome-container">            
            <h2 class="welcome-title"> {{ iframeProperty.headerTitle }} </h2>            
            <p class="welcome-subtitle"> {{ iframeProperty.headerDescription }} </p>
          </div>
        </div>
        <div
          v-for="(message, index) in getCurrentChatHistory()"
          :key="index"
          class="chat-bubble"
          :class="message.role"
        >
          <div class="message-content" v-html="parseContent(message)"></div>
          <div v-if="message.imageDataUrls && message.imageDataUrls.length" class="attached-images">
            <img v-for="(src, i) in message.imageDataUrls" :key="i" :src="src" :alt="message.imageNames?.[i] || 'attachment'" />
          </div>
          <div v-else-if="message.imageDataUrl" class="attached-image">
            <img :src="message.imageDataUrl" :alt="message.imageName || 'attachment'" />
          </div>
        </div>
        <div class="typing-indicator" v-if="isTyping">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex"
import { marked } from 'marked';
import { createAnswerStreamSanitizer, HALLUCINATION_SENTINEL } from "../utils/answerStream";

export default {
  data() {
    return {
      chatHistory: [],
      conversationIndex: "",
      conversationId:"",
      conversationSummaries: [],
      currentConversationIndex: -1,
      currentConvId: "",
      disableInput: false,
      isTyping: false,
      isMobile: window.innerWidth <= 768,
      isNewConversation: true,
      streamingStatus: {},
      streamSequence: 0,
      activeStreamId: null,
      sidebarOpen: false,
      userInputText: '',
      userQuery: "",
  attachedImages: [],
  attachedImagePreviews: [],
      maxImageSizeMB: 50,
      serverConversationTurnLimitText: '',
    };
  },
  computed: {
    ...mapState({
      iframeProperty: (state) => {
        return state.iframeProperty;
      },
    }),
    maximumConversationTurn() {
      const maximumConversationTurn = Number(this.iframeProperty.maximumConversationTurn);
      return Number.isInteger(maximumConversationTurn) && maximumConversationTurn > 0
        ? maximumConversationTurn
        : null;
    },
    currentConversationUserTurnCount() {
      return this.chatHistory.filter((message) => message.role === 'user').length;
    },
    conversationTurnLimitReached() {
      if (this.serverConversationTurnLimitText) {
        return true;
      }
      return this.maximumConversationTurn !== null &&
        this.currentConversationUserTurnCount >= this.maximumConversationTurn;
    },
    conversationTurnLimitText() {
      if (this.serverConversationTurnLimitText) {
        return this.serverConversationTurnLimitText;
      }
      return `Conversation is limited to ${this.maximumConversationTurn} turn`;
    },
  },
  methods: {
  ...mapActions({
      fetchAllConversations: "fetchAllConversations",
      fetchIframeProperties: "fetchIframeProperties",
      fetchSpecificConversation: "fetchSpecificConversation",
      createConversationSummary: "createConversationSummary",
      createConversationAnswer: "createConversationAnswer",
      deleteConversationAction: "deleteConversationAction",
      logoutUser: "logoutUser",
    }),
    parseContent(message) {
      if (message && message.content) {
        const sanitizedContent = message.content.split(HALLUCINATION_SENTINEL).join('');
        let content = marked.parse(sanitizedContent);
        // Add `target="_blank"` to all anchor tags
        content = content.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
        return content;
      }
      return ''
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    newline() {
      '\n'
    },
    handleResize() {
      this.$refs.chatContainer.style.marginTop = `${(this.$refs?.headerWrapper?.offsetHeight ?? 64) / 2}px`;
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.sidebarOpen = true; // Ensure sidebar is open on desktop
      }
    },
    updateHeaderHeight() {
      const header = this.$el.querySelector('.header__wrapper');
      if (header) {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
      }
    },
    login() {
      this.$router.push({ name: 'Login' });
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    triggerFilePicker() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    clearAttachedImages() {
      this.attachedImagePreviews.forEach((url) => {
        try { URL.revokeObjectURL(url); } catch (e) { console.error('revokeObjectURL error:', e); }
      });
      this.attachedImages = [];
      this.attachedImagePreviews = [];
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    removeAttachedImage(index) {
      const [removed] = this.attachedImagePreviews.splice(index, 1);
      if (removed) {
        try { URL.revokeObjectURL(removed); } catch (e) { console.error('revokeObjectURL error:', e); }
      }
      this.attachedImages.splice(index, 1);
    },
    onImagesSelected(event) {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
      for (const file of files) {
        if (!file.type.startsWith('image/')) {
          this.showToast('Please select a valid image file', 'error');
          continue;
        }
        const sizeMB = file.size / (1024 * 1024);
        if (sizeMB > this.maxImageSizeMB) {
          this.showToast(`Image too large (>${this.maxImageSizeMB}MB)`, 'error');
          continue;
        }
        this.attachedImages.push(file);
        this.attachedImagePreviews.push(URL.createObjectURL(file));
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    showToast(msg, severity= "success", lifeTime = 2500) {
      let tconfig = {
        summary: msg,
        severity: severity,
      };
      if (lifeTime) {
        tconfig["life"] = lifeTime;
      }
      this.$toast.add(tconfig);
    },
    ensureStreamingAssistantMessage(assistantMessageIndex) {
      if (assistantMessageIndex !== null && this.chatHistory[assistantMessageIndex]?.role === 'assistant') {
        return assistantMessageIndex;
      }
      this.chatHistory.push({ role: 'assistant', content: '' });
      return this.chatHistory.length - 1;
    },
    appendStreamingAssistantContent(assistantMessageIndex, content) {
      if (!content) {
        return assistantMessageIndex;
      }
      const nextAssistantMessageIndex = this.ensureStreamingAssistantMessage(assistantMessageIndex);
      this.chatHistory[nextAssistantMessageIndex].content += content;
      return nextAssistantMessageIndex;
    },
    clearStreamingAssistantContent(assistantMessageIndex) {
      if (assistantMessageIndex !== null && this.chatHistory[assistantMessageIndex]?.role === 'assistant') {
        this.chatHistory[assistantMessageIndex].content = '';
      }
      return assistantMessageIndex;
    },
    removeEmptyStreamingAssistantMessage(assistantMessageIndex) {
      if (
        assistantMessageIndex !== null &&
        this.chatHistory[assistantMessageIndex]?.role === 'assistant' &&
        this.chatHistory[assistantMessageIndex].content === ''
      ) {
        this.chatHistory.splice(assistantMessageIndex, 1);
        return null;
      }
      return assistantMessageIndex;
    },
    cancelActiveStream() {
      this.activeStreamId = null;
      if (this.currentConversationIndex !== -1) {
        this.streamingStatus[this.currentConversationIndex] = false;
      }
      this.streamingStatus[-1] = false;
    },
    startNewConversation(wasDeleted = false) {      
      this.cancelActiveStream();
      this.isTyping = false; 
      this.isNewConversation = true;
      this.currentConversationIndex = -1;
      this.disableInput = false;
      this.userInputText = '';
      this.chatHistory = [];
      this.serverConversationTurnLimitText = '';
      this.clearAttachedImages();
      !wasDeleted && this.closeSidebar();
    },
    async sendMessage() {
      if (this.conversationTurnLimitReached) {
        return;
      }
      this.disableInput = true;
      if (this.userInputText.trim() === '') {
        this.disableInput = false;
        return;
      }
        // We need to pass userQuery to addConversationSummary function
        // this.userQuery = this.userInputText.trim();


      let submittedUserMessage = null;
      try {
        this.userQuery = this.userInputText.trim();
        this.userInputText = '';
        this.serverConversationTurnLimitText = '';

        // If images are attached, convert to base64 for payload
        let imagesMeta = [];
        let imageDataUrls = [];
        try {
          if (this.attachedImages.length) {
            const base64s = await Promise.all(this.attachedImages.map(f => this.fileToBase64(f)));
            imagesMeta = base64s.map((dataUrl, i) => ([
              String(dataUrl).split(',')[1],
              this.attachedImages[i].type,
              this.attachedImages[i].name,
            ]));
            imageDataUrls = base64s;
          }
        } catch (e) {
          console.error('Image encoding failed', e);
          this.showToast('Failed to attach some images', 'error');
        }

        submittedUserMessage = {
          role: 'user',
          content: this.userQuery,
          imageDataUrls,
          imageNames: this.attachedImages.map(f => f.name),
        };
        this.chatHistory.push(submittedUserMessage);
        // Clear attached images after pushing to history
        this.clearAttachedImages();
        this.isTyping = true;
        this.scrollToBottomChat();
        if (this.currentConversationIndex === -1) {
          // We need conversation_id to make answer call which we get from summary call
          await this.addConversationSummary();
        }
        this.scrollToBottomChat();
        if(this.conversationIndex!==""){
            // This case covers the previous conversations chat i.e., already existing convos
            var idForPrevConvo = this.conversationSummaries[this.conversationIndex].id
            this.conversationId = idForPrevConvo
        } else{
            // This case, where id is passed for new conversation scenario which gets from addConversationSummary function
            var idForNewConvo = this.currentConvId
            this.conversationId = idForNewConvo
        }
        const payload = {
          conversation_id: this.conversationId,
          question: this.userQuery,
          images: imagesMeta,
        };
        const response = await this.createConversationAnswer(payload)
        this.isTyping = false;
        const streamId = ++this.streamSequence;
        this.activeStreamId = streamId;
        const streamingConversationIndex = this.currentConversationIndex;
        this.streamingStatus[streamingConversationIndex] = true;
        const decoder = new TextDecoder("utf-8", { fatal: false, ignoreBOM: true, stream: true });
        if (response) {
            // Handle the streaming response
            const reader = response.body.getReader();
            const sanitizer = createAnswerStreamSanitizer();
            let assistantMessageIndex = null;
            let hallucinationDetected = false;
            let streamInterrupted = false;
            let continueReading = true;
            const applySanitizedChunk = ({ reset, text }) => {
              if (reset) {
                hallucinationDetected = true;
              }
              assistantMessageIndex = this.appendStreamingAssistantContent(assistantMessageIndex, text);
            };
            while (continueReading) {
              if (this.activeStreamId !== streamId) {
                streamInterrupted = true;
                continueReading = false;
                continue;
              }
              const { done, value } = await reader.read();
                if (done) {
                    continueReading = false;
                    continue;
                }
                // Check if streaming is paused for the current conversation                  
                  if (!this.streamingStatus[streamingConversationIndex]) {
                    streamInterrupted = true;
                    continueReading = false;
                    continue; // Exit the loop if streaming is paused
                  }
                // Handle each chunk of data from the streaming response
                const chunk = decoder.decode(value, { stream: true });
                applySanitizedChunk(sanitizer.push(chunk));
            }
            if (!streamInterrupted) {
              applySanitizedChunk(sanitizer.push(decoder.decode()));
              applySanitizedChunk(sanitizer.flush());
              if (hallucinationDetected) {
                assistantMessageIndex = this.removeEmptyStreamingAssistantMessage(assistantMessageIndex);
                this.showToast('Warning: This response may contain hallucinated URLs.', 'warn');
              }
            }
        }else{
            console.error('Unexpected response type:', response);
        }
        this.disableInput = false;
      } catch (error) {
        console.error(error);
        this.isTyping = false;
        this.disableInput = false;
        if (error.status === 429 && error.message) {
          this.serverConversationTurnLimitText = error.message;
          this.userInputText = '';
          if (submittedUserMessage) {
            const submittedMessageIndex = this.chatHistory.indexOf(submittedUserMessage);
            if (submittedMessageIndex !== -1) {
              this.chatHistory.splice(submittedMessageIndex, 1);
            }
          }
          this.clearAttachedImages();
        }
        this.showToast(error.message || "An unexpected error occurred", "error");
      }
    },
    async addConversationSummary() {
         let payload = {
            question: this.userQuery,
         }
         // Check if contact_id exists in sessionStorage
         let contactId = sessionStorage.getItem('contact_id');
         if (contactId) {
           payload.contact_id = contactId; // Add contact_id only if it's not null
         }
         else {
           payload.cookie = sessionStorage.getItem('cookie');
         }
         try{
             const resp = await this.createConversationSummary(payload)
             // User starts new conversation as soon he comes to Chat Page
             this.conversationId = resp.data.conversation_id
             // When user goes to old convo first and then creates new convo, this assignment helps
             this.currentConvId = resp.data.conversation_id
             this.conversationIndex = ""
             if(resp){
                  // Adding latest conversation in conversationSummaries array for keeping track of id.
                  await this.loadNewConversations()
                  this.currentConversationIndex = this.conversationSummaries.length - 1;
                  this.scrollToBottomConversations();
             }
         }catch(error){
             this.showToast("An unknown error has occurred in the CloudCIX ML service. CloudCIX support has been notified,please try again later.", "error")
         }
    },
    async loadConversation(index) {      
      this.isTyping = false
      this.isNewConversation = false;
      this.serverConversationTurnLimitText = '';
      this.closeSidebar();
      const previousConversationIndex = this.currentConversationIndex;
      if (previousConversationIndex !== -1) {
        this.streamingStatus[previousConversationIndex] = false;
      }
      this.streamingStatus[index] = true;
      if(this.conversationSummaries[index].created){
        // To continue chatting in old conversation, storing index and getting it's id in createConversationSummary function
        this.conversationIndex = index
      } else{
        // Empty this variable for new conversation starting scenario
        this.conversationIndex = ""
      }
      var id = this.conversationSummaries[index].id;
      if (id) {
        sessionStorage.setItem('current_conversation_id', id)
        const resp = await this.fetchSpecificConversation(id)
        if (resp) {
          this.chatHistory = []
          for (let i = 0; i < resp.length; i++) {
            this.chatHistory.push({
                role: 'user',
                content: resp[i].question,
                imageDataUrls: (resp[i].question_images || []).map(img => `data:${img[1]};base64,${img[0]}`),
                imageNames: (resp[i].question_images || []).map(img => img[2]),
            });
            this.chatHistory.push({ role: 'assistant', content: resp[i].answer });
          }
        }
        // This helps us to take the visibility to the bottom of the screen after clicking on any conversation.
        this.scrollToBottomChat();
      }
      if (index < 0 || index >= this.conversationSummaries.length) {
        return;
      }
      this.currentConversationIndex = index;
      await this.getCurrentChatHistory()
    },
    async deleteConversation(index) {
      try {
          var id = this.conversationSummaries[index].id;
          // Call a Vuex action or API endpoint to delete the conversation
          await this.deleteConversationAction(id);
          // After deletion, update the conversation summaries
          this.conversationSummaries.splice(index, 1);
          this.startNewConversation(true);
          // Optionally, reset the current conversation index or perform other tasks
          this.currentConversationIndex = -1;
        } catch (error) {
            console.error("Error deleting conversation:", error);
        }
    },
    getCurrentChatHistory() {
       if (this.currentConversationIndex !== -1) {
        this.conversationSummaries[this.currentConversationIndex].conversationHistory = this.chatHistory ;
        const selectedConversation = this.conversationSummaries[this.currentConversationIndex];
        return selectedConversation.conversationHistory;
      }

      return this.chatHistory;
    },

    async loadConversations(){
      let payload = {
        question: this.userQuery,
      }
      // Check if contact_id exists in sessionStorage
      let contactId = sessionStorage.getItem('contact_id');
      if (contactId) {
        payload.contact_id = contactId; // Add contact_id only if it's not null
      }
      else {
        payload.cookie = sessionStorage.getItem('cookie');
      }
      const resp = await this.fetchAllConversations(payload)
      if (resp) {
        const convObject = Object.entries(resp.content);
        for (let i = 0; i < convObject.length; i++){
          this.conversationSummaries.push(convObject[i][1])
        }
        // This helps us to take the visibility to the bottom of the screen after loading all conversations.
        this.scrollToBottomConversations();
      }
    },
    async loadNewConversations(){
        let payload = {
          question: this.userQuery,
        }
        // Check if contact_id exists in sessionStorage
        let contactId = sessionStorage.getItem('contact_id');
        if (contactId) {
          payload.contact_id = contactId; // Add contact_id only if it's not null
        }
        else {
          payload.cookie = sessionStorage.getItem('cookie');
        }
        const resp = await this.fetchAllConversations(payload)
        if (resp) {
            const convObject = Object.entries(resp.content);
            for (let i = convObject.length-1; i < convObject.length; i++)
                this.conversationSummaries.push(convObject[i][1])
        }
    },
    scrollToBottomChat() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatContainer;
        chatContainer.scrollTop = chatContainer.scrollHeight;
      });
    },
    scrollToBottomConversations() {
      this.$nextTick(() => {
        const convoContainer = this.$refs.convoContainer;
        convoContainer.scrollTop = convoContainer.scrollHeight;
      });
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    !this.iframeProperty.isLoaded && await this.fetchIframeProperties()
    await this.loadConversations();
    const current_conversation_id = sessionStorage.getItem('current_conversation_id');
    if(current_conversation_id) {
      const conversationIdx = this.conversationSummaries.findIndex(conversation => Number(conversation.id) === Number(current_conversation_id))
      if (conversationIdx !== -1) {
        await this.loadConversation(conversationIdx);
      }
    }
    this.updateHeaderHeight();
    window.addEventListener('resize', this.updateHeaderHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.updateHeaderHeight);
  },
};

</script>

<style scoped lang="scss">
$sidebar-width: 244px;
$nav-height: 60px;

body {
  margin: 0;
  padding: 0;
  background-color: #343541;
  display: flex;
}

.chat-page {
  &__wrapper {
    display: flex;
    justify-content: end;
  }
}

.draggable {
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

.header {
  &__wrapper {
    width: 100%;
  display: flex;
  padding: 10px 5px;
  justify-content: space-between;
  align-items: center;
  position: relative;

    .toggle_button {
      background: none;
      border: none;
      cursor: pointer;
      width: max-content !important;
      margin: 0 !important;
      padding-top: 10px;
      position: absolute;
      top: 0;
    }
  }

  &__content {
    padding: 0 2.5rem;
    text-align: center;
    width: 100%;

    &__description {
      font-size: small;
      line-height: 12px;
    }

    &__title {
      font-weight: 500;
    }
  }
  
}


.image-container {
  justify-content: center;
  background-color: #2f3136;
  margin: 0;
  border-bottom: 2px solid #fff;
  border-top: 2px solid #fff;
  display: flex;
  align-items: center;
  padding: 10px;
}
.attach-button {
  border: none;
  background-color: #fff;
  font-size: 18px;
  padding: 10px 12px;
  margin: auto 6px auto 0;
  border-radius: 5px;
  cursor: pointer;
}

.chat-bubble {
  overflow-wrap: break-word;
}

.chat-bubble.assistant {
  background-color: #2b362f;
  color: white;
  align-self: flex-start;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  min-height: max-content;
  overflow-x: auto;
  margin-bottom: 10px;
  padding: 1px 15px;
  width: 100%;
  text-align: left;

  .message-content {
    :deep(a) {
      color: white;
    }
  }
}

.image-preview {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
  border-radius: 6px;
  margin-top: 6px;
}
.image-previews {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.image-preview img {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 4px;
}
.attached-images {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.attached-images img {
  max-width: 180px;
  max-height: 180px;
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.1);
}
.image-preview .image-name {
  font-size: 12px;
  color: #333;
}
.image-preview .remove-image {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
}

.attached-image {
  margin-top: 6px;
}
.attached-image img {
  max-width: 180px;
  max-height: 180px;
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.1);
}

.chat-bubble.user {
  background: #a3b8ab;
  color: white;
  align-self: flex-end;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 10px;
  padding: 1px 15px;
  width: 100%;
  text-align: right;
}

.image-container img {
  width: 60px;
  height: 50px;
  margin-right: 10px;
}

h1 {
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.button-container:hover {
  background-color: #202123;
  color: white;
}

.side-bar {
  background-color: #202123;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 8px;
  right: auto;
  width: $sidebar-width;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  nav {
    span {
      cursor: pointer;
    }
  }
}

.side-bar button {
  background-color: transparent;
  border-radius: 10px;
  color: #fff;
  width:80%;
  font-size: 15px;
  font-weight: 500;
  padding: 10px;
  cursor: pointer;
  margin-top: 20px;
  margin-bottom:20px;
}

.side-bar button:hover {
  background-color: #2f3136;
}

.side-bar .history {
  padding: 10px;
}

.side-bar nav {
  border-top: 0.5px solid #2f3136;
  padding: 10px;
  margin-top: auto;
  margin-bottom: 2px;
}

.conversation-summaries {
  list-style-type: none;
  padding: 1%;
  overflow-y: auto
}

.conversation-summaries::-webkit-scrollbar {
  width: 5px; /* Set the width of the scrollbar */
}

.conversation-summaries::-webkit-scrollbar-thumb {
  background-color: #888; /* Set the color of the scrollbar thumb */
}

.conversation-summaries::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Set the color of the scrollbar track */
}

.conversation-summary {
  background-color: transparent;
  border-radius: 10px;
  color: #fff;
  display: flex;
  flex-wrap: nowrap;
  width:75%;
  font-size: 15px;
  font-weight: 500;
  padding: 10px;
  cursor: pointer;
  margin-left:20px;  
  position: relative;
}

.conversation-name{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; 
}

.delete-icon {
  height: 16px;
  width: 16px;
  color: white;
  position: absolute;
  right: 0;
  fill: currentColor;
}

.conversation-summary:hover {
  background-color: #2f3136;
}

.conversation-summary.active {
  background-color: #2f3136;
  color: #fff;
}

.main {
  margin-top: var(--header-height, 46px);
  height: calc(100vh - var(--header-height, 46px));
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  text-align: center;
  width: calc(100% - #{$sidebar-width});
  padding: 20px;
  padding-bottom: 0;
  background-color: white;
  transition: transform 0.3s ease;
}

.main .input-container {
  margin-top: 8px;
  display: flex;
  align-items: flex-start; /* Adjust alignment to top */
  justify-content: space-between;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 0.25px;
  width: 100%;
  z-index: 1;
}

.main .conversation-limit-container {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 0.25px;
  width: 100%;
  padding: 10px 12px;
  z-index: 1;
}

.conversation-limit-message {
  color: #202123;
  flex: 1;
  font-size: 16px;
  text-align: left;
}

.conversation-limit-button {
  background-color: #202123;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 14px;
  white-space: nowrap;
}

.main .input-container textarea {
  color: #202123;
  flex: 1;
  font-size: 16px;
  overflow-y: auto;
  padding: 12px 15px;
  resize: none;
  max-height: 100px; /* Limit the input height */
}

.main .output-container {
  height: 100%;
  /* Set a maximum height for the conversation area */
  overflow-y: auto;
  /* Enable scrolling when content exceeds the max height */
  padding: 10px;
  padding-top: 0;
  margin-top: 10px;
  width: 100%;
}

.output-container::-webkit-scrollbar {
  width: 5px; /* Set the width of the scrollbar */
}

.output-container::-webkit-scrollbar-thumb {
  background-color: #888; /* Set the color of the scrollbar thumb */
}

.output-container::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Set the color of the scrollbar track */
}

.main #submit {
  border: none;
  background-color: #fff;
  font-size: 20px;
  padding: 10px 15px;
  margin: auto;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.main .info {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  padding: 10px;
  background-color: #1c2369;
}

#outputContainer {
  background-color: #1c2369;
  margin-left: 20px;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

#output {
  background-color: #232642;
  color: #fff;
  margin-bottom: 10px;
}

/* Empty State Styling */
.empty-conversation-message { 
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 20px;
    color: #666;
}
.welcome-container { 
    max-width: 600px; 
    text-align: center; 
} 
.welcome-title { 
    font-size: 1.5rem;
    margin-bottom: 10px; 
    color: #333; 
}
.welcome-subtitle {
    font-size: 1rem; 
    line-height: 1.4; 
    color: #666; 
}

/* Empty State Styling end */

/* Typing Indicator Styles start */
.typing-indicator {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    background: #2b362f;
    width: 74px;
    height: 34px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
}

.dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    background: white;
    border-radius: 50%;
    margin: 0 6px;
    animation: bounce 1.4s infinite ease-in-out;
    opacity: 0.5;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
        opacity: 0.5;
    }
    50% {
        transform: translateY(-5px);
        opacity: 1;
    }
}
/* Typing Indicator styles end */

.header__wrapper {
      min-height: 48px;
}

@media (max-width: 768px) {
  .chat-bubble.assistant {
    margin-left: 0 !important;
    max-width: 100%;
  }

  .conversation-summary {
    text-align: start;
    width: 100%;
    margin-left: 0;
    padding-right: 30px;

    .delete-icon {
      right: 10px;
    }
  }

  h1 {
    font-size: 28px;
    padding: 10px;
  }
  
  .main {
    width: 100%;

    .input-container {
      width: 100%;
      margin: auto;
      box-shadow: none;
      padding-top: 10px;

      #submit {
        margin-left: 0;
      }

      #userInput {
        width: 100% !important;
      }
    }
  }

  .output-container {
   margin-top: 16px; 
   padding-bottom: 40px;
   height: 100%;
   display: block;
  }

  /* Show sidebar when it's open */
  .side-bar {
    &__wrapper {
      background: #2c2d2e6e;
    }
    
    transition: transform 0.2s ease;
    height: 100%;
    justify-content: start;
    padding: 5px;
    transform: translateX(-100%);
    max-width: $sidebar-width;
    width: 65%;
    z-index: 999999;

    .header__wrapper {
      padding: 0 !important;
    }

    button {
      width: 100%;
      font-size: 14px;
      padding: 8px;
      margin-top: 8px;
    }

    &--open {
      z-index: 99999;
      transform: translateX(0) !important;
      .header__wrapper {
        height: 48px;

        .toggle_button {
          padding-top: 5px;
        }
      }
    }
  }
}
</style>
